import React, { useEffect, useMemo, useState } from "react";
import Button from "../../../components/Button/Button";
import { FaSave, FaTimes } from "react-icons/fa";
import { updateHeures_enseignement } from "../../../services/heuresenseignementServices";
import { toast } from "react-toastify";

const MONTHS_FR = [
  "Janvier","Février","Mars","Avril","Mai","Juin",
  "Juillet","Août","Septembre","Octobre","Novembre","Décembre"
];

function moisToLabel(mois) {
  // attend "YYYY-MM"
  if (!mois || !/^\d{4}-\d{2}$/.test(mois)) return mois || "";
  const [y, m] = mois.split("-").map((x) => parseInt(x, 10));
  const label = MONTHS_FR[(m || 1) - 1] || "";
  return `${label} ${y}`;
}

const UpdateHoursModal = ({ isOpen, onClose, heure, refreshData }) => {
  const [heures, setHeures] = useState("");

  // Reset & sync à chaque ouverture / changement de ligne
  useEffect(() => {
    if (isOpen && heure) {
      setHeures(
        heure?.heures !== undefined && heure?.heures !== null
          ? String(heure.heures)
          : ""
      );
    } else {
      setHeures("");
    }
  }, [isOpen, heure]);

  const monthLabel = useMemo(() => moisToLabel(heure?.mois), [heure?.mois]);

  const handleClose = () => {
    setHeures("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const val = parseFloat(heures);
    if (Number.isNaN(val) || val < 0) {
      toast.error("Veuillez saisir un nombre d’heures valide.");
      return;
    }
    try {
      await updateHeures_enseignement(heure.id, { heures: val });
      toast.success("Heures d'enseignement mises à jour avec succès.");
      handleClose();
      refreshData();
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de la mise à jour des heures d'enseignement.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={handleClose}
      />

      <div className="relative mx-auto w-full max-w-xl mt-[8vh] rounded-2xl shadow-2xl overflow-hidden">
        {/* Header gradient */}
        <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500 px-5 py-4">
          <h3 className="text-white text-lg font-bold">
            Mettre à jour les heures d’enseignement
          </h3>
        </div>

        <div className="bg-white dark:bg-slate-900 p-5">
          {/* Contexte */}
          <div className="mb-4 flex flex-wrap gap-2 text-xs">
            {heure?.semaine && (
              <span className="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-800 px-2 py-1 text-slate-700 dark:text-slate-200">
                Semaine ISO : {heure.semaine}
              </span>
            )}
            {heure?.mois && (
              <span className="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-800 px-2 py-1 text-slate-700 dark:text-slate-200">
                Mois : {monthLabel}
              </span>
            )}
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
                Heures
              </label>
              <input
                type="number"
                step="0.25"
                min="0"
                autoFocus
                name="heures"
                value={heures}
                onChange={(e) => setHeures(e.target.value)}
                className="input input-bordered w-full"
                required
              />
              <p className="mt-1 text-[11px] text-slate-500 dark:text-slate-400">
                Saisissez un nombre (ex. 1, 1.5, 2.25…). Les quarts d’heure sont acceptés.
              </p>
            </div>

            <div className="flex justify-end gap-3 pt-2">
              <Button
                text="Annuler"
                icon={FaTimes}
                type="button"
                onClick={handleClose}
                className="gap-2 !bg-slate-100 !text-slate-800 hover:!bg-slate-200 dark:!bg-slate-800 dark:!text-slate-100 dark:hover:!bg-slate-700 !rounded-xl"
              />
              <Button
                text="Enregistrer"
                icon={FaSave}
                type="submit"
                className="gap-2 !rounded-xl"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateHoursModal;
